// useDirectAuthEnabled — F8.7b · fetches the DIRECT_AUTH_ENABLED kill-switch.
// Mirrors useLandingV2Enabled pattern. Cached in-memory per mount.
//
// Dev override: `?force_direct_auth=1` query param forces enabled=true. Only
// honored when NODE_ENV !== "production" so live traffic can't be spoofed.
import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";

export default function useDirectAuthEnabled() {
    const [state, setState] = useState({ loading: true, enabled: false, error: null });

    useEffect(() => {
        // Dev override — check first (short-circuits network).
        if (typeof window !== "undefined" && process.env.NODE_ENV !== "production") {
            const params = new URLSearchParams(window.location.search);
            if (params.get("force_direct_auth") === "1") {
                setState({ loading: false, enabled: true, error: null });
                return;
            }
        }
        let mounted = true;
        (async () => {
            try {
                const data = await apiFetch("/kill-switches/direct-auth-enabled");
                if (mounted) setState({ loading: false, enabled: !!data.enabled, error: null });
            } catch (e) {
                if (mounted) setState({ loading: false, enabled: false, error: e });
            }
        })();
        return () => { mounted = false; };
    }, []);

    return state;
}
